// extracted by mini-css-extract-plugin
export var standaloneTable = "_cs-0";
export var standaloneTableWithBodyFill = "_cs-1";
export var withExtraHeader = "_cs-2";